<template>
    <a :href=url class="self-btn-icon-move">
        <span class="self-btn-icon-move__title">{{title}}</span>

        <span class="self-btn-icon-move__icons">
    <span class="self-btn-icon-move__icons__primary">
        <IconArrowAltSVG/>
    </span>

    <span class="self-btn-icon-move__icons__secondary">
        <IconArrowAltSVG/>
    </span>
  </span>
    </a>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import IconArrowAltSVG from '../assets/static/icons-src/icon-arrow-alt.svg'

@Component({
    components: {
        IconArrowAltSVG
    }
})
export default class LinksListItem extends Vue {
    @Prop(String) readonly title!: string;
    @Prop(String) readonly url!: string;
}
</script>

<style scoped>

</style>
